import common from "@/assets/js/common";
import router from "../../router";
const user ={
    state:{
        token:"",
        loginName:"",
        accessToken:"",
        refreshToken:"",
        userId:"",
        userName:"",
        exTime:0,
        tno:'',
        tenantId:'',
        /**websocket心跳定时器 */
        socketTimer:{
            timer1:null,
            timer2:null,
            timer3:null,
            ws:null,
            connect:true,
            url:'',
        },
        /**用户基本信息详情 */
        userInfo:{},
        /**应用详情 */
        appDetail:{
            appName: "虚仿实训教学平台"
        }
    },
    mutations:{
        /**同步用户信息时获取用户名称 */
        queryUserName(state,value){
            state.userName=value;
            state.userInfo.userName=value;
            common.setExpiresCookie("userName",value,state.exTime)
        },
        /**修改用户基本信息详情 */
        changeUserInfo(state,data){
            state.userInfo=data;
        },
        /**修改应用详情 */
        changeAppInfo(state,data){
            state.appDetail=data;
        },
        /**退出登录状态应用详情 */
        logoutAppInfo(state){
            state.appDetail={
                appName: "虚仿实训教学平台"
            };
        },
        changeSocket(state,data){
            state.socketTimer[data.label]=data.value;
        },
        clearTimer(state){
            state.socketTimer.timer1&&clearTimeout(state.socketTimer.timer1);
            state.socketTimer.timer2&&clearTimeout(state.socketTimer.timer2);
            state.socketTimer.timer3&&clearTimeout(state.socketTimer.timer3);
        },
        del_token(state){
            state.token = "";
            state.loginName = "";
            state.refreshToken = "";
            state.userId = "";
            state.tenantId='';
            state.tno='';
            localStorage.clear();
            sessionStorage.clear();
            common.clearAllCookie();
            state.userInfo={};
            state.socketTimer.connect=false;
            let ws=state.socketTimer.ws;
            ws&&ws.close();
            if(router.currentRoute.path=='/personCenter'){
                router.push('/');
            }
        },
        /**登录存储 */
        addUserData(state,data){
            state.token= data.accessToken;
            state.refreshToken = data.refreshToken;
            state.userId = data.userId;
            state.loginName = data.loginName;
            state.exTime = data.exTime;
            state.userName = data.userName;
            state.tno=data.tno;
            state.tenantId=data.tenantId;
            common.setExpiresCookie("token",data.accessToken,data.exTime)
            sessionStorage.setItem('token',data.accessToken);
            sessionStorage.setItem('userId',data.userId);
            common.setExpiresCookie("userId",data.userId,data.exTime)
            common.setExpiresCookie("loginName",data.loginName,data.exTime)
            common.setExpiresCookie("userName",encodeURIComponent(data.userName),data.exTime)
            common.setExpiresCookie("tno",data.tno,data.exTime)
            common.setExpiresCookie("tenantId",data.tenantId,data.exTime)
            const threeHoursLater = new Date(data.refreshTokenExTime);
            common.setExpiresCookie("exTime",data.exTime,threeHoursLater.toString());
            common.setExpiresCookie("refreshToken",data.refreshToken,threeHoursLater.toString()) ;
        },
        /**刷新token存储 */
        refreshUserData(state,data){
            var userId=common.getCookie('userId')||'';
            var tenantId=common.getCookie('tenantId')||'';
            var loginName=common.getCookie('loginName')||'';
            var userName=common.getCookie('userName')||'';
            var tno=common.getCookie('tno')||'';
            var token=common.getCookie('token')||'';
            common.setExpiresCookie("token",token,data.exTime);
            common.setExpiresCookie("userId",userId,data.exTime);
            common.setExpiresCookie("loginName",loginName,data.exTime);
            common.setExpiresCookie("userName",userName,data.exTime);
            common.setExpiresCookie("tno",tno,data.exTime);
            common.setExpiresCookie("tenantId",tenantId,data.exTime);
            const threeHoursLater = new Date(data.refreshTokenExTime);
            common.setExpiresCookie("exTime",data.exTime,threeHoursLater.toString());
            common.setExpiresCookie("refreshToken",data.refreshToken,threeHoursLater.toString()) ;
        },
        /**存储用户信息 */
        saveInfo(state){
            state.token=common.getCookie('token')||'';
            state.userName=decodeURIComponent(common.getCookie('userName'))||'';
            state.userId=common.getCookie('userId')||'';
            state.loginName=common.getCookie('loginName')||'';
            state.tno=common.getCookie('tno')||'';
            state.tenantId=common.getCookie('tenantId')||'';
        },
        /**清空用户存储信息 */
    },
    actions:{
        clearSocket({state,commit}){
            commit('clearTimer');
            state.socketTimer={
                timer1:null,
                timer2:null,
                timer3:null,
                ws:null,
                connect:true,
                url:'',
            };
        },
        setUserData({commit},data){
            commit("addUserData",data);
        },
        disConnect({commit}){
            commit('del_token');
            commit('clearTimer');
            commit('updateNavList');
        },
        removeToken({commit}){
            commit('del_token');
        },

    }
};
export default user
